import { render, staticRenderFns } from "./IListenToSockets.vue?vue&type=template&id=2ba41069&"
import script from "./IListenToSockets.vue?vue&type=script&lang=js&"
export * from "./IListenToSockets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports